import { useEffect } from 'react';
import useAppState from '../../AppStore';

const useDraw = () => {
  const activeTool = useAppState((state) => state.activeTool);
  const setSelectedFeatureId = useAppState((state) => state.setSelectedFeatureId);
  const setIsDrawActive = useAppState((state) => state.setIsDrawActive);

  useEffect(() => {
    if (activeTool === 'draw') {
      setIsDrawActive(true);
      return;
    }

    setIsDrawActive(false);
    setSelectedFeatureId(null);
  }, [activeTool]);
};

export default useDraw;
